import { render, staticRenderFns } from "./SamTextList.vue?vue&type=template&id=76e71468&scoped=true&"
import script from "./SamTextList.vue?vue&type=script&lang=js&"
export * from "./SamTextList.vue?vue&type=script&lang=js&"
import style0 from "./SamTextList.vue?vue&type=style&index=0&id=76e71468&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e71468",
  null
  
)

export default component.exports